import { handleize } from '../../core/helpers';

const getSizefit = (product) => {
  // The size/height options need to be there even if the default sizefit_size and sizefit_height are not set!

  // Note: data-extra-product-info-title html gets rewritten from dynamic-product-extra.js
  const is_plus_size = product.variants.edges[0].node.title.includes('Plus Size - ');

  const sizefit_html = `
    <h4 class="product-extra-v3__description__title">SIZE + FIT</h4>

    <h5 data-extra-size-height-title class="product-extra-v3__description__subtitle">Model Info</h5>
    <ul data-extra-size-height>
      <li>Model is wearing size: <span data-quickview-extra-size>${product.astrSizefitSize?.value ?? ''}</span></li>
      <li>Model height is: <span data-quickview-extra-height>${product.astrSizefitHeight?.value ?? ''}</span></li>
    </ul>

    <h5 data-extra-product-info-title class="product-extra-v3__description__subtitle">Product info for size ${is_plus_size ? '1X' : 'small'}</h5>
    <ul>
      ${(product.astrSizefitLength !== null) ? `<li>Length: <span data-quickview-extra-length>${product.astrSizefitLength.value}</span></li>` : ''}
      ${(product.astrSizefitFit !== null) ? `<li>Fits: <span data-quickview-extra-fit>${product.astrSizefitFit.value}</span></li>` : ''}
      ${(product.astrSizefitBust !== null) ? `<li>Bust <span data-quickview-extra-bust>${product.astrSizefitBust.value}</span></li>` : ''}
      ${(product.astrSizefitWaist !== null) ? `<li>Waist <span data-quickview-extra-waist>${product.astrSizefitWaist.value}</span></li>` : ''}
      ${(product.astrSizefitFit !== null) ? `<li>Fits <span data-quickview-extra-hip>${product.astrSizefitFit.value}</span></li>` : ''}
      ${(product.astrSizefitInseam !== null) ? `<li>Inseam <span data-quickview-extra-inseam>${product.astrSizefitInseam.value}</span></li>` : ''}
    </ul>
  `;

  return sizefit_html;
};

const getDetailCare = (product) => {
  let detailcare_html = '';

  const has_detailcare = (product.astrDetailcareWashingInstructions !== null || product.astrDetailcareFabricContent !== null || product.astrDetailcareStyleNumber !== null || product.astrDetailcareAttribute1 !== null || product.astrDetailcareAttribute2 !== null || product.astrDetailcareAttribute3 !== null);

  if (has_detailcare) {
    detailcare_html = `
      <h4 class="product-extra-v3__description__title">DETAILS + CARE</h4>

      <ul>
        ${(product.astrDetailcareWashingInstructions !== null) ? `<li><span data-quickview-extra-washing-instructions>${product.astrDetailcareWashingInstructions.value}</span></li>` : ''}
        ${(product.astrDetailcareFabricContent !== null) ? `<li>Self: <span data-quickview-extra-fabric>${product.astrDetailcareFabricContent.value}</span></li>` : ''}
        ${(product.astrDetailcareAttribute1 !== null) ? `<li><span data-quickview-extra-attribute-1>${product.astrDetailcareAttribute1.value}</span></li>` : ''}
        ${(product.astrDetailcareAttribute2 !== null) ? `<li><span data-quickview-extra-attribute-2>${product.astrDetailcareAttribute2.value}</span></li>` : ''}
        ${(product.astrDetailcareAttribute3 !== null) ? `<li><span data-quickview-extra-attribute-3>${product.astrDetailcareAttribute3.value}</span></li>` : ''}
        ${(product.astrDetailcareStyleNumber !== null) ? `<li>Style #<span data-quickview-extra-style>${product.astrDetailcareStyleNumber.value}</span></li>` : ''}
      </ul>
    `;

    return detailcare_html;
  }

  // if (product.astrDetailcare !== null) {
  //   detailcare_html = `
  //     <h4 class="product-extra-v3__description__title">DETAILS + CARE</h4>
  //     ${product.astrDetailcare.value}
  //   `;
  // }

  return detailcare_html;
};

const getVariantJson = (product) => {
  const default_sizefit_height = product.astrSizefitHeight?.value ?? '';
  const default_sizefit_size = product.astrSizefitSize?.value ?? '';
  const default_sizefit_hip = product.astrSizefitHip?.value ?? '';
  const default_sizefit_waist = product.astrSizefitWaist?.value ?? '';
  const default_sizefit_bust = product.astrSizefitBust?.value ?? '';
  const default_sizefit_fit = product.astrSizefitFit?.value ?? '';
  const default_sizefit_length = product.astrSizefitLength?.value ?? '';
  const default_sizefit_inseam = product.astrSizefitInseam?.value ?? '';
  
  let json = `{ "color": "default", "description": ${JSON.stringify(product.descriptionHtml)}, "sizefit_height": ${JSON.stringify(default_sizefit_height)}, "sizefit_size": ${JSON.stringify(default_sizefit_size)}, "sizefit_hip": ${JSON.stringify(default_sizefit_hip)}, "sizefit_waist": ${JSON.stringify(default_sizefit_waist)}, "sizefit_bust": ${JSON.stringify(default_sizefit_bust)}, "sizefit_fit": ${JSON.stringify(default_sizefit_fit)}, "sizefit_length": ${JSON.stringify(default_sizefit_length)}, "sizefit_inseam": ${JSON.stringify(default_sizefit_inseam)}}`;

  let current_color = '';
  let current_variant_description = '';
  let current_variant_sizefit_height = '';
  let current_variant_sizefit_size = '';
  let current_variant_sizefit_hip = '';
  let current_variant_sizefit_waist = '';
  let current_variant_sizefit_bust = '';
  let current_variant_sizefit_fit = '';
  let current_variant_sizefit_length = '';
  let current_variant_sizefit_inseam = '';

  product.variants.edges.forEach((variant) => {
    // console.log(variant.node);

    if (variant.node.selectedOptions[0].name === 'Color') {
      const variant_color = handleize(variant.node.selectedOptions[0].value);

      if (current_color != variant_color) {
        if (current_color != '') {
          if (json.length) {
            json += ',';
          }
  
          json += `{ "color": "${current_color}", "description": ${JSON.stringify(current_variant_description)}, "sizefit_height": ${JSON.stringify(current_variant_sizefit_height)}, "sizefit_size": ${JSON.stringify(current_variant_sizefit_size)}, "sizefit_hip": ${JSON.stringify(current_variant_sizefit_hip)}, "sizefit_waist": ${JSON.stringify(current_variant_sizefit_waist)}, "sizefit_bust": ${JSON.stringify(current_variant_sizefit_bust)}, "sizefit_fit": ${JSON.stringify(current_variant_sizefit_fit)}, "sizefit_length": ${JSON.stringify(current_variant_sizefit_length)}, "sizefit_inseam": ${JSON.stringify(current_variant_sizefit_inseam)}}`;
        }

        current_color = variant_color;
        current_variant_description = '';
        current_variant_sizefit_height = '';
        current_variant_sizefit_size = '';
        current_variant_sizefit_hip = '';
        current_variant_sizefit_waist = '';
        current_variant_sizefit_bust = '';
        current_variant_sizefit_fit = '';
        current_variant_sizefit_length = '';
        current_variant_sizefit_inseam = '';
      }

      if (current_variant_description === '' && variant.node.astrStyleDescription !== null && typeof variant.node.astrStyleDescription !== 'undefined' && typeof variant.node.astrStyleDescription.value !== 'undefined' && variant.node.astrStyleDescription.value !== '') {
        current_variant_description = variant.node.astrStyleDescription.value;
      }

      if (current_variant_sizefit_height === '' && variant.node.astrStyleSizefitHeight !== null && typeof variant.node.astrStyleSizefitHeight !== 'undefined' && typeof variant.node.astrStyleSizefitHeight.value !== 'undefined' && variant.node.astrStyleSizefitHeight.value !== '') {
        current_variant_sizefit_height = variant.node.astrStyleSizefitHeight.value;
      }

      if (current_variant_sizefit_size === '' && variant.node.astrStyleSizefitSize !== null && typeof variant.node.astrStyleSizefitSize !== 'undefined' && typeof variant.node.astrStyleSizefitSize.value !== 'undefined' && variant.node.astrStyleSizefitSize.value !== '') {
        current_variant_sizefit_size = variant.node.astrStyleSizefitSize.value;
      }

      if (current_variant_sizefit_hip === '' && variant.node.astrStyleSizefitHip !== null && typeof variant.node.astrStyleSizefitHip !== 'undefined' && typeof variant.node.astrStyleSizefitHip.value !== 'undefined' && variant.node.astrStyleSizefitHip.value !== '') {
        current_variant_sizefit_hip = variant.node.astrStyleSizefitHip.value;
      }

      if (current_variant_sizefit_waist === '' && variant.node.astrStyleSizefitWaist !== null && typeof variant.node.astrStyleSizefitWaist !== 'undefined' && typeof variant.node.astrStyleSizefitWaist.value !== 'undefined' && variant.node.astrStyleSizefitWaist.value !== '') {
        current_variant_sizefit_waist = variant.node.astrStyleSizefitWaist.value;
      }

      if (current_variant_sizefit_bust === '' && variant.node.astrStyleSizefitBust !== null && typeof variant.node.astrStyleSizefitBust !== 'undefined' && typeof variant.node.astrStyleSizefitBust.value !== 'undefined' && variant.node.astrStyleSizefitBust.value !== '') {
        current_variant_sizefit_bust = variant.node.astrStyleSizefitBust.value;
      }

      if (current_variant_sizefit_fit === '' && variant.node.astrStyleSizefitFit !== null && typeof variant.node.astrStyleSizefitFit !== 'undefined' && typeof variant.node.astrStyleSizefitFit.value !== 'undefined' && variant.node.astrStyleSizefitFit.value !== '') {     
        current_variant_sizefit_fit = variant.node.astrStyleSizefitFit.value;
      }

      if (current_variant_sizefit_length === '' && variant.node.astrStyleSizefitLength !== null && typeof variant.node.astrStyleSizefitLength !== 'undefined' && typeof variant.node.astrStyleSizefitLength.value !== 'undefined' && variant.node.astrStyleSizefitLength.value !== '') {
        current_variant_sizefit_length = variant.node.astrStyleSizefitLength.value;
      }

      if (current_variant_sizefit_inseam === '' && variant.node.astrStyleSizefitInseam !== null && typeof variant.node.astrStyleSizefitInseam !== 'undefined' && typeof variant.node.astrStyleSizefitInseam.value !== 'undefined' && variant.node.astrStyleSizefitInseam.value !== '') {
        current_variant_sizefit_inseam = variant.node.astrStyleSizefitInseam.value;
      }
    }
  });

  // Add data from last color
  if (current_color !== '') {
    if (json.length) {
      json += ',';
    }

    json += `{ "color": "${current_color}", "description": ${JSON.stringify(current_variant_description)}, "sizefit_height": ${JSON.stringify(current_variant_sizefit_height)}, "sizefit_size": ${JSON.stringify(current_variant_sizefit_size)}, "sizefit_hip": ${JSON.stringify(current_variant_sizefit_hip)}, "sizefit_waist": ${JSON.stringify(current_variant_sizefit_waist)}, "sizefit_bust": ${JSON.stringify(current_variant_sizefit_bust)}, "sizefit_fit": ${JSON.stringify(current_variant_sizefit_fit)}, "sizefit_length": ${JSON.stringify(current_variant_sizefit_length)}, "sizefit_inseam": ${JSON.stringify(current_variant_sizefit_inseam)}}`;
  }

  return `<script type="application/json" data-quickview-product-extra-variant-json>[${json}]</script>`;
};

// Look at product-extra-v3 as reference
// Make sure the tab IDs are unique
export default (product) => {
  return `
  ${getVariantJson(product)}
  <section class="product-extra-v3">
    <span id="quicklook-tabsTitle" class="visually-hidden">Product description, returns and shipping</span>
    <div class="product-extra-v3__head" role="tablist" aria-labelledby="quicklook-tabsTitle">
      <div id="quicklook-tab-1" type="button" role="tab" aria-selected="true" aria-controls="quicklook-tabpanel-1" class="product-extra-v3__tab active" data-product-extra-tab data-product-extra-tab-type="description">
        <span class="focus">Description</span>
      </div>

      <div id="quicklook-tab-2" type="button" role="tab" aria-selected="false" aria-controls="quicklook-tabpanel-2" class="product-extra-v3__tab" data-product-extra-tab data-product-extra-tab-type="return-shipping" tabindex="-1">
        <span class="focus">Return & Shipping</span>
      </div>
    </div>

    <div id="quicklook-tabpanel-1" role="tabpanel" tabindex="0" aria-labelledby="quicklook-tab-1" class="product-extra-v3__description" data-product-extra-content data-product-extra-content-type="description">
      <div class="product-extra-v3__description__description" data-quickview-extra-description>${product.descriptionHtml}</div>

      ${getSizefit(product)}
      ${getDetailCare(product)}
    </div>

    <div id="quicklook-tabpanel-2" role="tabpanel" tabindex="0" aria-labelledby="quicklook-tab-2" class="visually-hidden" class="product-extra-v3__return-shipping" data-product-extra-content data-product-extra-content-type="return-shipping">
      ${product.returnsShipping.value}
    </div>
  </section>
  `;
};
